import type { GameType } from '@ottd/api';
import { useTranslation } from 'react-i18next';

import { SegmentedTabs } from '@/components/prototype/segmented-tabs';

/*
 * The ALL / CITY BUILDER / COMPANY VALUE segmented filter (Homepage, Games).
 */
export type TypeFilter = 'all' | GameType;

/** Filter values in display order, paired with their `common:filter.*` key. */
const OPTIONS: Array<{ value: TypeFilter; labelKey: string }> = [
  { value: 'all', labelKey: 'filter.all' },
  { value: 'CB', labelKey: 'filter.cityBuilder' },
  { value: 'CV', labelKey: 'filter.companyValue' },
];

interface FilterTabsProps {
  value: TypeFilter;
  onChange: (value: TypeFilter) => void;
  /** Overrides the group's accessible name; defaults to the generic one. */
  label?: string;
  className?: string;
}

export function FilterTabs({ value, onChange, label, className }: FilterTabsProps) {
  const { t } = useTranslation('common');

  return (
    <SegmentedTabs
      value={value}
      onChange={onChange}
      label={label ?? t('filter.label')}
      className={className}
      options={OPTIONS.map((option) => ({ value: option.value, label: t(option.labelKey) }))}
    />
  );
}
